import { render, staticRenderFns } from "./DateBlock.vue?vue&type=template&id=67eab664&scoped=true&lang=pug"
import script from "./DateBlock.vue?vue&type=script&lang=ts"
export * from "./DateBlock.vue?vue&type=script&lang=ts"
import style0 from "./DateBlock.vue?vue&type=style&index=0&id=67eab664&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eab664",
  null
  
)

export default component.exports